import { useState, useEffect } from 'react';
import { getRemainingTime } from '../../lib/inactivityCheck';
import { isArsenalSessionContext } from '../../lib/sessionContext';

export function InactivityIndicator() {
  const [remainingTime, setRemainingTime] = useState(0);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = getRemainingTime();
      setRemainingTime(remaining);
      
      // Afficher un avertissement dans les 2 dernières minutes
      setShowWarning(isArsenalSessionContext() && remaining > 0 && remaining < 2 * 60 * 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  if (!showWarning) return null;

  const minutes = Math.floor(remainingTime / 60000);
  const seconds = Math.floor((remainingTime % 60000) / 1000);

  return (
    <div className="fixed-top" style={{ top: '90px', right: '20px', zIndex: 1050 }}>
      <div className="bg-warning text-dark px-4 py-3 rounded shadow-lg" style={{ 
        animation: 'pulse 2s infinite',
        maxWidth: '300px',
        border: '2px solid #f59e0b'
      }}>
        <div className="d-flex align-items-center">
          <span className="fs-4 me-2">⚠️</span>
          <div>
            <div className="fw-bold mb-1">Session expire bientôt</div>
            <div className="small">
              Temps restant: {minutes}:{seconds.toString().padStart(2, '0')}
            </div>
            <div className="small text-muted">
              Bougez la souris pour prolonger
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
